import { render, staticRenderFns } from "./AddExamResult.vue?vue&type=template&id=87b4e0f6&"
import script from "./AddExamResult.vue?vue&type=script&lang=js&"
export * from "./AddExamResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports